<template>
  <div class="section mt-5">
    <div class="container-fluid text-center">
      <div class="row justify-content-md-center">
        <div class="col-md-12 col-lg-12">
          <h2 style=" font-weight: 900; text-decoration: underline;">GIROS INDUSTRIALES</h2>
          <p class="category">BRINDANDO SERVICIOS EN DIVERSOS SECTORES INDUSTRIALES, COMO:</p>
          <div class="row" style="text-align: center;">
            <div class="col-6 col-md-2 form-group mx-auto mb-5">
              <img src="@/assets/papelera.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
              <br>
              <a style="font-size: 16px; color: #7b0f0f; font-weight: 900;">INDUSTRIA PAPELERA</a>
            </div>
            <div class="col-6 col-md-2 form-group mx-auto mb-5">
              <img src="@/assets/cementera.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
              <br>
              <a style="font-size: 16px; color: #7b0f0f; font-weight: 900;">INDUSTRIA CEMENTERA Y CALERA</a>
            </div>
            <div class="col-6 col-md-2 form-group mx-auto mb-5">
              <img src="@/assets/telecomunicaciones.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
              <br>
              <a style="font-size: 16px; color: #7b0f0f; font-weight: 900;">INDUSTRIA DE TELECOMUNICACION</a>
            </div>
            <div class="col-6 col-md-2 form-group mx-auto mb-5">
              <img src="@/assets/alimenticia.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
              <br>
              <a style="font-size: 16px; color: #7b0f0f; font-weight: 900;">INDUSTRIA DE ALIMENTICIA</a>
            </div>
            <div class="col-6 col-md-2 form-group mx-auto mb-5">
              <img src="@/assets/subestaciones_e.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
              <br>
              <a style="font-size: 16px; color: #7b0f0f; font-weight: 900;">SUBESTACIONES E INSTALACIONES ELÉCTRICAS</a>
            </div>
          </div>

          <div class="row" style="text-align: center;">
            <div class="col-6 col-md-2 form-group mx-auto mb-5">
              <img src="@/assets/automotriz.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
              <br>
              <a style="font-size: 16px; color: #7b0f0f; font-weight: 900;">INDUSTRIA AUTOMOTRIZ</a>
            </div>
            <div class="col-6 col-md-2 form-group mx-auto mb-5">
              <img src="@/assets/transformacion.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
              <br>
              <a style="font-size: 16px; color: #7b0f0f; font-weight: 900;">INDUSTRIA DE TRANSFORMACIÓN</a>
            </div>
            <div class="col-6 col-md-2 form-group mx-auto mb-5">
              <img src="@/assets/golf.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
              <br>
              <a style="font-size: 16px; color: #7b0f0f; font-weight: 900;">CLUBS DE GOLF</a>
            </div>
            <div class="col-6 col-md-2 form-group mx-auto mb-5">
              <img src="@/assets/residencial.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
              <br>
              <a style="font-size: 16px; color: #7b0f0f; font-weight: 900;">RESIDENCIAL</a>
            </div>
            <div class="col-6 col-md-2 form-group mx-auto mb-5">
              <img src="@/assets/oem.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
              <br>
              <a style="font-size: 16px; color: #7b0f0f; font-weight: 900;">FABRICANTE DE EQUIPO ORIGINAL</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  }
};
</script>
<style>
.tab-content.tab-content-padding {
  padding: 20px;
}
</style>
